import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingNav from '../components/landing/LandingNav';
import Hero from '../components/landing/Hero';
import Problem from '../components/landing/Problem';
import HowItWorks from '../components/landing/HowItWorks';
import LeadDifference from '../components/landing/LeadDifference';
import PricingPreview from '../components/landing/PricingPreview';
import LandingFooter from '../components/landing/LandingFooter';
import styles from './LandingPage.module.css';

// Public marketing home. Owns its own scroll container because the global
// stylesheet sets `body { overflow: hidden }` for the app shell.
export default function LandingPage() {
  const location = useLocation();

  // When another page links to a section (e.g. footer "Pricing" from /about),
  // it navigates here with { state: { scrollTo: id } }. Scroll to it on mount.
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    // Wait a tick so the sections are laid out before scrolling.
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <LeadDifference />
        <PricingPreview />
      </main>
      <LandingFooter />
    </div>
  );
}
